












import Vue, { PropType } from 'vue'
import { DCategoriaDePermissao, ValorPSelect } from 'src/tipos'

export interface Permissao {
  id: DCategoriaDePermissao;
  name: string;
}

interface Computed {
  valueInterno: ValorPSelect;
}

interface Props {
  value: DCategoriaDePermissao;
  desativado: boolean;
}

export default Vue.extend<{}, {}, Computed, Props>({
  name: 'DCategoriaDePermissao',

  props: {
    value: {
      type: String as PropType<DCategoriaDePermissao>,
      required: true
    },
    desativado: {
      type: Boolean,
      required: false
    }
  },

  computed: {
    valueInterno: {
      get (): ValorPSelect {
        const opcoesFormatadas = {
          loaded: [{id: 'empregado', name: 'notificação de alerta dos empregados'}, {id: 'gestor', name: 'notificação de ocorrência para os gestores'}],
          selected: null,
          loading: false
        } as ValorPSelect
        const permissao = this.value

        const listaDeTodasAsPermissoes = [...opcoesFormatadas.loaded]
        const permissaoSelecionada = (listaDeTodasAsPermissoes as Permissao[]).find((value: Permissao) => {
          return value.id === permissao
        })

        const opcoesFormatadasDoSeletor = {
          selected: permissaoSelecionada,
          loaded: opcoesFormatadas.loaded
        }

        return opcoesFormatadasDoSeletor
      },
      set (valueInternoAtualizado: ValorPSelect): void {
        const permissaoSelecionada = (valueInternoAtualizado.selected as Permissao).id
        this.$emit('input', permissaoSelecionada)
      }
    }
  }
})
